import React from 'react';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import { FilledSquareIcon, EmptySquareIcon } from 'global/components/PerformIcons';
import { getColorFromScore } from 'global/styles';
import useStyles from './styles';
import { useView } from 'global/hooks/useView';
import { get } from '../../lib/lodash';

// Expects props.score as a float between 0 and 1
// score values -1 are processed to black

export default (props) => {
  const { isBw } = props;
  const classes = useStyles(props);
  const { isDark } = useView();
  if (props.score === null) {
    return <EmptySquareIcon color="disabled" />;
  } else if (props.selected) {
    return <CheckBoxIcon className={classes.icon} onClick={props.onClick} style={{ color: isDark ? 'white' : 'black' }} />;
  } else if (props.indeterminate) {
    return <IndeterminateCheckBoxIcon className={classes.icon} onClick={props.onClick} style={{ color: isDark ? 'white' : 'black' }} />;
  }

  const sc = typeof props.score === 'string' ? parseFloat(props.score) : props.score;
  const stroke = props.useBlankCheckbox ? (isDark ? 'white' : 'black') : 'none';
  const opacity = props.useBlankCheckbox ? '0.4' : '1';

  const hasRanges = props.scorecardConfig ? [get(props, 'scorecardConfig.minScore', 0), get(props, 'scorecardConfig.maxScore', 100)] : undefined;

  return <FilledSquareIcon className={classes.icon} onClick={props.onClick} style={{ color: getColorFromScore(sc, hasRanges, isBw), stroke: stroke, fillOpacity: opacity, strokeWidth: 2 }} />;
};
